import * as React from "react";

import { formPageChangedEventPath } from "../../../../../Engine/Core/EventManagement/ExternalEvents/ExternalEvents";
import { SectionName, UnitId, unitIdToLegacyUnitId } from "../../UnitId/UnitId";
import { useFormObject } from "../../../../FormObjectProvider";
import { useExternalEvent } from "../../../../UseExternalEvent";
import { IForm } from "../../../../../Engine/Form/IForm";

import { IsFilledContext } from "./IsFilledContext";

interface ResolveOptionalPageProps {
    optional: boolean;
    unitId: UnitId;
    updateEmptyUnits: (unitId: UnitId, empty: boolean) => void;
    children: React.ReactNode;
}

export function isUnitFilled(section: SectionName, optional: boolean, form: IForm) {
    return optional ? !form.sections.isSectionIgnored(section) : true;
}

export function ResolveOptionalPage(props: ResolveOptionalPageProps): JSX.Element {
    const form = useFormObject();
    const section = React.useMemo(() => unitIdToLegacyUnitId(props.unitId) as SectionName, [props.unitId]);

    const [isFilled, setIsFilled] = React.useState(() => isUnitFilled(section, props.optional, form));

    const handlePageChanged = React.useCallback(() => {
        if (props.optional) {
            setIsFilled(!form.sections.isSectionIgnored(section));
        }
    }, [section, props.optional]);

    React.useEffect(() => {
        if (props.optional) {
            props.updateEmptyUnits(props.unitId, !isFilled);
        }
    }, [isFilled, props.optional]);

    useExternalEvent(formPageChangedEventPath(section), handlePageChanged);

    return <IsFilledContext.Provider value={isFilled}>{props.children}</IsFilledContext.Provider>;
}
